import { AxiosPromise } from 'axios';
import api from './api';

interface BodyRecaptcha {
  recaptcha_response: string;
}

class RecaptchaService {
  verify = (body: BodyRecaptcha): AxiosPromise => {
    return api.post('api/pjtacom/recaptcha/', body);
  };
}

export default RecaptchaService;
